import React from 'react';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import PropTypes from 'prop-types';

import IconClose from 'components/icons/iconClose';
import IconArrowRight from 'components/icons/iconArrowRight';
import ShowroomLocatorResults from 'components/consumer/consumer-new-footer/components/ShowroomLocatorResults';
import useShowroomLocator, {
  validateZipcodeInput,
} from 'hooks/useShowroomLocator';

const MobileNavbarShowroomLocator = ({ onClose }) => {
  const {
    stores,
    loading,
    error,
    hasSearched,
    handleSearch,
    handleCloseResults,
    handleViewAll,
  } = useShowroomLocator();

  return (
    <div className="w-[280px] px-4 py-3 [&_a]:!text-brand [&_a]:!underline">
      <div className="flex justify-between items-center mb-2">
        <div className="text-gray font-bold text-base">
          Find your closest showroom
        </div>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className="text-gray p-1"
            aria-label="Close"
          >
            <IconClose width={12} height={12} />
          </button>
        )}
      </div>

      <Formik
        initialValues={{ zipcode: '' }}
        validate={validateZipcodeInput}
        onSubmit={({ zipcode }) => {
          handleSearch(zipcode);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className="flex items-stretch">
              <input
                id="mobile-navbar-showroom-zipcode"
                name="zipcode"
                type="text"
                placeholder="Zip Code"
                value={values.zipcode}
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength="5"
                autoComplete="postal-code"
                className="flex-1 border border-gray-light5 px-3 py-2 text-sm outline-none focus:border-brand"
              />
              <button
                type="submit"
                className="bg-brand text-white px-3 flex items-center justify-center [&_path]:fill-white"
                aria-label="Search"
              >
                <IconArrowRight width={16} height={10} />
              </button>
            </div>
            {touched.zipcode && errors.zipcode && (
              <div className="text-red text-xs mt-1">{errors.zipcode}</div>
            )}
          </form>
        )}
      </Formik>

      <div className="text-xs text-gray font-normal my-2">Within 50 miles</div>

      {hasSearched && (
        <ShowroomLocatorResults
          loading={loading}
          error={error}
          stores={stores}
          onClose={handleCloseResults}
          isMobile
        />
      )}

      <div className="mt-3">
        <Link
          to="/showrooms/"
          onClick={handleViewAll}
          className="text-brand underline text-sm !font-semibold"
        >
          View All
        </Link>
      </div>
    </div>
  );
};

MobileNavbarShowroomLocator.propTypes = {
  onClose: PropTypes.func,
};

export default MobileNavbarShowroomLocator;
